import type {
  AnchorScrollTarget,
  FacesheetCriteriaRow,
  FacesheetHtmlSummaryData,
  FacesheetOutlineItem,
  ReferenceContentState,
} from './types';

// exclude demographics section
export const buildFacesheetOutlineItems = (
  summary: FacesheetHtmlSummaryData,
): FacesheetOutlineItem[] =>
  summary.criteriaSections.map((section) => ({
    id: section.id,
    label: section.title,
    anchorId: section.anchorId,
  }));

const criteriaRowsIncludeAnchor = (
  rows: FacesheetCriteriaRow[],
  anchorId: string,
): boolean =>
  rows.some(
    (row) =>
      row.anchorId === anchorId ||
      criteriaRowsIncludeAnchor(row.children ?? [], anchorId),
  );

export const getOutlineActiveAnchorId = (
  summary: FacesheetHtmlSummaryData,
  activeAnchorId?: string,
) => {
  if (!activeAnchorId) return undefined;
  if (activeAnchorId === 'section-demographics') return undefined;

  const activeSection = summary.criteriaSections.find(
    (section) =>
      section.anchorId === activeAnchorId ||
      criteriaRowsIncludeAnchor(section.rows, activeAnchorId),
  );

  return activeSection?.anchorId ?? activeAnchorId;
};

export const getReferenceScrollTarget = (
  referenceState: ReferenceContentState,
  referenceId: string,
): {
  targetPage?: number;
  anchorScrollTarget?: AnchorScrollTarget;
} => {
  const reference = referenceState.criteriaRow.references.find(
    (ref) => ref.id === referenceId,
  );

  if (!reference) return {};

  if (reference.scrollTarget.kind === 'page') {
    return { targetPage: reference.scrollTarget.pageNumber };
  }

  return { anchorScrollTarget: reference.scrollTarget };
};
